import { getFirebase } from "react-redux-firebase";
import { refSave } from './entity.actions'
import { refUpdate } from './entity.actions'
import { alertActions } from './alert.actions'
import { filesConstants } from '../constants/files.constants.js'

export const filesActions = {
  uploadFile,
  uploadFileIssues
};

function uploadFile(projectId, taskId, file) {
  const firebase = getFirebase();

  return (dispatch, getState) => {
    let snapshot;
    const currentRef = firebase.database().ref(`/projects/${projectId}/tasks/${taskId}/files/`)
    const currentKey = currentRef.push().key;

    return refSave(
      firebase,
      firebase.database().ref(`/projects/${projectId}/tasks/${taskId}/files/${currentKey}`),
      {
         fileName: file.name,
         fileSize: file.size,
         fileType: file.type,
         status: filesConstants.UPLOADING
      }
    )
    .then(() => {
      firebase.storage().ref(`/projects/${projectId}/tasks/${taskId}/files/${currentKey}`)
        .put(file)
        .then(snap => {
           snapshot = snap;

           firebase.storage().ref(`/projects/${projectId}/tasks/${taskId}/files/${currentKey}`)
             .getDownloadURL()
             .then(url => {
                return refUpdate(
                  firebase,
                  firebase.database().ref(`/projects/${projectId}/tasks/${taskId}/files/${currentKey}`),
                  {
                    fileState: snapshot.state,
                    fileDownloadURL: url,
                    status: filesConstants.DOWNLOADED
                  }
                )
             })
             .then(() => {
               dispatch(alertActions.success('Upload Successful'))
             })
        })
    })
    .catch(() => {
      dispatch(alertActions.error('Error Uploading'))
    })
  }
}

function uploadFileIssues (projectId, issueId, file) {
  const firebase = getFirebase();

  return (dispatch, getState) => {
    let snapshot;
    const currentRef = firebase.database().ref(`/projects/${projectId}/issues/${issueId}/files/`)
    const currentKey = currentRef.push().key;

    return refSave(
      firebase,
      firebase.database().ref(`/projects/${projectId}/issues/${issueId}/files/${currentKey}`),
      {
         fileName: file.name,
         fileSize: file.size,
         fileType: file.type,
         status: filesConstants.UPLOADING
      }
    )
    .then(() => {
      firebase.storage().ref(`/projects/${projectId}/issues/${issueId}/files/${currentKey}`)
        .put(file)
        .then(snap => {
           snapshot = snap;

           firebase.storage().ref(`/projects/${projectId}/issues/${issueId}/files/${currentKey}`)
             .getDownloadURL()
             .then(url => {
                return refUpdate(
                  firebase,
                  firebase.database().ref(`/projects/${projectId}/issues/${issueId}/files/${currentKey}`),
                  {
                    fileState: snapshot.state,
                    fileDownloadURL: url,
                    status: filesConstants.DOWNLOADED
                  }
                )
             })
             .then(() => {
               dispatch(alertActions.success('Upload Successful'))
             })
        })
    })
    .catch((error) => {
      dispatch(alertActions.error('Error Uploading'))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/files.actions.js